import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: "https://cb0a1bcaadf0502e00b8eab2740300e0@o1165291.ingest.sentry.io/4506520106369024",
  environment: environment,
  sendDefaultPii: true,
  debug: false,
  integrations: [
    Sentry.browserTracingIntegration({
      enableInp: true,
    }),
  ],
  tracesSampleRate: environment.startsWith("development") ? 1 : 0.1,
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/ca.vessi\.com\//,
    /^https:\/\/vessi\.com\//,
  ],
  replaysSessionSampleRate: environment.startsWith("development") ? 1 : 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend: (error, hint) => beforeSend(error, hint),
});

window.onerror = function (message, source, lineno, colno, error) {
  Sentry.withScope((scope) => {
    scope.setExtra("column", colno);
    scope.setExtra("line", lineno);
    scope.setExtra("source", source);
    Sentry.captureException(error);
  });
};
function beforeSend(error, hint) {
  const shouldIgnore = shouldIgnoreError(error, hint) ? null : error;
  return shouldIgnore;
}

function shouldIgnoreError(error, hint) {
  return isRecaptchaBadTimeoutRejection(error, hint) || isNetworkError(error);
}

function isRecaptchaBadTimeoutRejection(_, hint) {
  return hint.originalException === "Timeout";
}

const typeErrorFetchFailedValues = new Set([
  "Failed to fetch",
  "NetworkError when attempting to fetch resource.",
  "Load failed",
  "Network request failed",
  "Failed to load resource",
]);

const blockedUrls = [
  "https://config.gorgias",
  ".js.map",
  "dl-app-embed-block.js",
  "https://o1165291.ingest.sentry.io",
  "https://i3.vessi.com/nb-collector",
  "https://tags.srv.stackadapt.com",
  "https://ca.vessi.com/a/elevar/static/getelevar/",
  "https://vessi.com/a/elevar/static/getelevar/",
  "/a/elevar",
  "https://api.juniphq.com",
  "https://www.youtube.com",
  "https://play.google.com",
  "https://analytics.google.com",
  "https://strn.rise-ai.com",
  "https://ct.pinterest.com/stats/",
  "https://geo.lovely-app.com/",
  "https://cdn.omniconvert.com/"
];

function isNetworkError(error) {
  const exception = error.exception?.values?.[0];
  const now = Date.now();

  if (
    exception?.type !== "TypeError" ||
    !typeErrorFetchFailedValues.has(exception.value)
  ) {
    return false;
  }

  if (!error.breadcrumbs) {
    return false;
  }

  return hasErroneousBreadcrumb(error.breadcrumbs, now);
}

function hasErroneousBreadcrumb(breadcrumbs, now) {
  for (let i = breadcrumbs.length - 1; i >= 0; i--) {
    const breadcrumb = breadcrumbs[i];
    if (!breadcrumb) continue;

    if (breadcrumb.timestamp && now - breadcrumb.timestamp * 1000 > 5000) {
      break;
    }

    if (isErroneousBreadcrumb(breadcrumb)) {
      return true;
    }
  }

  return false;
}

function isErroneousBreadcrumb(breadcrumb) {
  if (
    breadcrumb.level !== "error" ||
    (breadcrumb.category !== "xhr" && breadcrumb.category !== "fetch")
  ) {
    return false;
  }

  const url = breadcrumb.data?.url;
  if (!url) return false;

  const isErroneous = blockedUrls.some(
    (blockedUrl) =>
      url === blockedUrl ||
      url.startsWith(blockedUrl) ||
      url.endsWith(blockedUrl)
  );
  return isErroneous;
}
